<template>
    <div class="row">
      <div :class="labelClass">{{ label }}:</div>
      <div class="col">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" :name="name" :id="name+'_1'" value="true" v-model="internalValue">
          <label class="form-check-label" :for="name+'_1'">Z</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" :name="name" :id="name+'_2'" value="false" v-model="internalValue">
          <label class="form-check-label" :for="name+'_2'">Brez</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" :name="name" :id="name+'_3'" value="undefined" v-model="internalValue">
          <label class="form-check-label" :for="name+'_3'">Vseeno</label>
        </div>
      </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue"

defineOptions({ name: "BoolFilter" })

const props = defineProps({
    label: { type: String, required: true },
    name: { type: String, required: true },
    modelValue: { type: String, default: "undefined" },
    labelClass: { type: String, default: "col-sm-4" },
  })

const emit = defineEmits(["update:modelValue"])

const internalValue = ref(props.modelValue)
watch(
  () => props.modelValue,
  (v) => {
    internalValue.value = v
  },
)
watch(internalValue, (v) => emit("update:modelValue", v))
</script>
